import MobileMeetingEnd from "./MobileMeetingEnd";

export default function MeetingEnd() {
  return (
    <>
      <MobileMeetingEnd />
    </>
  );
}
